import '@splidejs/splide/dist/css/splide.min.css';
import 'glightbox/dist/css/glightbox.min.css';
import Splide from '@splidejs/splide';
import GLightbox from 'glightbox';

import HeroSlider from '@components/HeroSlider/HeroSlider';
import ShortVideoSelection from "@components/ShortVideoSelection/ShortVideoSelection";

document.addEventListener('DOMContentLoaded', () => {
    HeroSlider();
    ProductTabs();
    DiaporamaSplide();
    ShortVideoSelection();
    DiaporamaManagment();
});


function ProductTabs() {
    const lists = document.querySelectorAll('.splide__animal-food');

    if(!lists.length) return;

    const btns = document.querySelectorAll('.AnimalFood-collections .TabSection');

    const config = {
        arrows: false,
        pagination: false,
        drag: false,
        perPage: 4,
        autoHeight: true,
        breakpoints: {
            1024: {
                perPage: 2,
                pagination: true,
                drag: true
            },
            768: {
                perPage: 2,
                pagination: true,
                drag: true
            }
        }
    };

    lists.forEach(list => {
        new Splide(list, config).mount();
    })

    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            btns.forEach(btn => btn.classList.remove('active'));
            btn.classList.add('active');
            lists.forEach(list => {
                list.classList.toggle('hidden',btn.dataset.tab !== list.id);
            })
        })
    })

}

function DiaporamaSplide() {
    const slider = document.querySelector('.DiaporamaSection .splide');

    if (!slider) return;

    new Splide(slider, {
        rewind: false,
        perPage: 2,
        gap: "0.75rem",
        padding: {
            right: "7.5rem",
        },
        pagination: false,
        arrows: true,
        breakpoints: {
            1024: {
                perPage: 1,
                padding: {
                    right: "3rem",
                }
            },
            640: {
                perPage: 1,
                autoplay: true,
                drag: true,
                arrows: false,
                padding: {
                    right: "1.5rem",
                }
            },
        }
    }).mount();
}

function DiaporamaManagment() {

    if (!window.DIAPORAMA) {
        console.warn('window.PANORAMA n\'est pas défini');
        return;
    }

    const glightboxElements = document.querySelectorAll('[data-glightbox]');

    if (!glightboxElements.length) return;

    glightboxElements.forEach((element) => {
        const diapoId = element.getAttribute('data-glightbox');

        if (!diapoId || !window.DIAPORAMA[diapoId]) {
            return;
        }

        const images = window.DIAPORAMA[diapoId];

        // Créer une instance GLightbox spécifique pour ce diaporama
        const lightbox = GLightbox({
            elements: images,
            touchNavigation: true,
            loop: true,
            autoplayVideos: false,
            onOpen: () => {
                console.log(`GLightbox ouvert pour le diaporama: ${diapoId}`);
            },
            onClose: () => {
                console.log(`GLightbox fermé pour le diaporama: ${diapoId}`);
            }
        });

        element.addEventListener('click', (e) => {
            e.preventDefault();

            lightbox.openAt(0);
        });
    });
}
